import styled from 'styled-components'

export const WindowHeader = styled.div`
  background: ${props => props.theme.header.background};
  padding: 18px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.p`
  color: ${props => props.theme.header.text};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin: 0;
`